import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { Container as DownloadAppWidgetContainer } from "~/components/home/footer/download-app-widget/styles";
import { Container as NewsletterContainer } from "~/components/home/footer/newsletter/styles";
import { Container as SubscriptionWidgetContainer } from "~/components/home/footer/subscription-widget/styles";
import { setFullViewportWidthStyles } from "~/lib/styles";

import { HomeFooterLogo } from "./logo";
import { HomeFooterSitemap } from "./sitemap";
import { HomeFooterSocialMedia } from "./social-media";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  padding-block-end: 12px;
  padding-inline: 20px;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-inline: 32px;
  }
`;

export const Wrapper = styled.div`
  max-inline-size: 1208px;
  margin-inline: auto;
  padding-block-start: 32px;
  border-block-start: 1px solid #000000;
`;

export const Header = styled.div`
  display: grid;
  grid-template-areas:
    "Logo"
    "SocialMedia";

  padding-block-end: 24px;

  ${props => props.theme.breakpoints.only("mobile")} {
    justify-content: center;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid-template-areas: "Logo SocialMedia";
    grid-template-columns: max-content 1fr;
    gap: 40px;

    padding-block-end: 32px;
  }
`;

export const StyledHomeFooterLogo = styled(HomeFooterLogo)`
  grid-area: Logo;

  ${props => props.theme.breakpoints.only("mobile")} {
    margin-block-end: 16px;
  }
`;

export const StyledHomeFooterSocialMedia = styled(HomeFooterSocialMedia)`
  grid-area: SocialMedia;

  ${props => props.theme.breakpoints.only("mobile")} {
    justify-content: center;
  }
`;

type ContentProps = {
  $isScmpSubscriber: boolean;
};
export const Content = styled("div", { ...transientOptions })<ContentProps>`
  display: grid;
  grid:
    "Sitemap"
    "Subscription"
    "Newsletter"
    "DownloadApp";

  padding-block-end: 24px;

  ${props => props.theme.breakpoints.up("tablet")} {
    ${props =>
      props.$isScmpSubscriber
        ? css`
            grid:
              "Sitemap Sitemap"
              "Newsletter DownloadApp"
              / 1fr 1fr;
          `
        : css`
            grid:
              "Sitemap Sitemap Sitemap"
              "Subscription Newsletter DownloadApp"
              / 1fr 1fr 1fr;
          `}
  }

  ${props => props.theme.breakpoints.up("homeDesktop")} {
    grid:
      "Sitemap . Subscription"
      "Sitemap . Newsletter"
      "Sitemap . DownloadApp" 1fr
      / 1fr 40px 300px;
  }
`;

export const StyledHomeFooterSitemap = styled(HomeFooterSitemap)`
  grid-area: Sitemap;
  ${props => props.theme.breakpoints.up("tablet")} {
    padding-inline-end: 20px;
  }
  ${props => props.theme.breakpoints.up("homeDesktop")} {
    padding-inline-end: 0;
  }
`;

const wrapperStyle = css`
  max-inline-size: 400px;
  margin-block: 0;
  margin-inline: auto;
`;
export const HomeFooterSubscriptionWidgetContainer = styled.div`
  grid-area: Subscription;
  border-block-end: 1px solid rgba(0, 0, 0, 0.2);

  margin-block-end: 12px;
  padding-block-end: 12px;

  ${props => props.theme.breakpoints.only("mobile")} {
    ${SubscriptionWidgetContainer} {
      ${wrapperStyle}
    }
  }

  ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
    margin-block-end: 0;
    margin-inline-end: 12px;
    padding-block-end: 0;
    padding-inline-end: 12px;
    border-inline-end: 1px solid rgba(0, 0, 0, 0.2);
    border-block-end: none;
  }
`;

export const HomeFooterNewsletterContainer = styled.div`
  grid-area: Newsletter;

  margin-block-end: 12px;
  padding-block-end: 12px;
  border-block-end: 1px solid rgba(0, 0, 0, 0.2);

  ${props => props.theme.breakpoints.only("mobile")} {
    ${NewsletterContainer} {
      ${wrapperStyle}
    }
  }

  ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
    margin-block-end: 0;
    margin-inline-end: 12px;
    padding-block-end: 0;
    padding-inline-end: 12px;
    border-inline-end: 1px solid rgba(0, 0, 0, 0.2);
    border-block-end: none;
  }
`;

export const HomeFooterDownloadAppWidgetContainer = styled.div`
  grid-area: DownloadApp;
  ${props => props.theme.breakpoints.only("mobile")} {
    ${DownloadAppWidgetContainer} {
      ${wrapperStyle}
    }
  }
`;

export const Copyright = styled.div`
  padding-block-start: 12px;

  font-weight: 400;
  font-size: 12px;
  border-block-start: 1px solid #00000033;

  text-align: center;
`;
